import { routes } from "@prmf/site-router";
import CallToAction from "./CallToAction";

export default function SustainabilityCTA() {
  return (
    <CallToAction
      image="/media/sustainability-cta.jpg"
      title="Our sustainability journey"
      text="See how we’ve achieved market-leading status and our plans for the future"
      to={routes.sustainability}
    />
  );
}
